import React from 'react';

import {SegmentConsentProps} from 'analytics/CookieConsentManagerContainer';
import {ConsentPreferences} from 'analytics/Destinations';

export interface NonSegmentConsentManagerBuilderProps {
  children: (props: SegmentConsentProps) => JSX.Element;
  shouldRequireConsent: () => boolean;
  cookieDomain: string;
  loadPreferences: () => {customPreferences?: ConsentPreferences};
  savePreferences: (preferences: {
    destinationPreferences: {};
    customPreferences: ConsentPreferences;
    cookieDomain: string;
  }) => void;
}

/**
 * Alternative to ConsentManagerBuilder for when segment is disabled. This is initially taken from
 * https://github.com/segmentio/consent-manager#consentmanagerbuilder , with modifications to make
 * it work with ENABLE_SEGMENT_ANALYTICS_JS = false. All analytics.js interactions were removed, the
 * custom/non-custom prefs system is no longer necessary, and we don't need an async loading state.
 */
export default class NonSegmentConsentManagerBuilder extends React.Component<NonSegmentConsentManagerBuilderProps> {
  private preferences = this.props.loadPreferences().customPreferences || {};
  private isConsentRequired = this.props.shouldRequireConsent();

  handleSaveConsent = (preferences: ConsentPreferences): void => {
    this.props.savePreferences({
      destinationPreferences: {},
      customPreferences: preferences,
      cookieDomain: this.props.cookieDomain,
    });
    window.location.reload();
  };

  render(): JSX.Element | null {
    return this.props.children({
      destinations: [],
      preferences: this.preferences,
      isConsentRequired: this.isConsentRequired,
      saveConsent: this.handleSaveConsent,
    });
  }
}
